import React from 'react';

const GtmBody: React.FC<{ gtmKey: string; }> = ({ gtmKey }) => (
    <noscript>
        <iframe
            title="Gtm body script"
            src={`https://www.googletagmanager.com/ns.html?id=GTM-${gtmKey}`}
            height={0}
            width={0}
            style={{ display: 'none', visibility: 'hidden' }}
        />
    </noscript>
);

export default GtmBody;
